import { render, staticRenderFns } from "./bortInfo.vue?vue&type=template&id=7aeb2094&scoped=true"
import script from "./bortInfo.vue?vue&type=script&lang=js"
export * from "./bortInfo.vue?vue&type=script&lang=js"
import style0 from "./bortInfo.vue?vue&type=style&index=0&id=7aeb2094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_1d815c3a82e414dc02ba46af5dbd33b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeb2094",
  null
  
)

export default component.exports